import AppletSubgroupType from '../applet/applet-subgroup-type.entity';
import CompanySession from './company-session.entity';
import User from './user.entity';

export default class UserSession {
  public accessToken = '';

  public createdAt = '';

  public expiresIn = '';

  public user: User = new User();

  public company: CompanySession = new CompanySession();

  public appletSubgroupType: AppletSubgroupType[];

  constructor(data: any = {}) {
    this.accessToken = data.access_token || '';
    this.createdAt = data.created_at || '';
    this.expiresIn = data.expires_in || '';
    this.user = new User(data.user);
    this.company = new CompanySession(data.company);
    this.appletSubgroupType = data.applet_subgroup_types
      ? data.applet_subgroup_types.map((appletType: any) => new AppletSubgroupType(appletType))
      : [];
  }
}
